import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useCountdown } from "@/hooks/useCountdown";
import { useLanguage } from "@/i18n/LanguageContext";
import { LAUNCH_DATE, ORDERS_CURRENT, ORDERS_GOAL, isCountdownActive } from "@/config/launchCountdown";

const STORAGE_KEY = "countdown_bar_dismissed";

const CountdownBar = () => {
  const { t } = useLanguage();
  const { days, hours, minutes, expired } = useCountdown(LAUNCH_DATE);
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(sessionStorage.getItem(STORAGE_KEY) === "1");
  }, []);

  if (dismissed || expired || !isCountdownActive()) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setDismissed(true);
  };

  const handleCta = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.getElementById("bestilling");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else window.location.href = "/#bestilling";
  };

  return (
    <div className="relative bg-gradient-to-r from-primary/20 via-primary/10 to-primary/20 border-b border-primary/30 text-foreground">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-center gap-3 sm:gap-6 text-[11px] sm:text-xs tracking-[0.15em] uppercase">
        <span className="hidden sm:inline text-foreground/90">
          {t("countdown.bar_text")
            .replace("{days}", String(days))
            .replace("{hours}", String(hours))
            .replace("{minutes}", String(minutes))
            .replace("{current}", String(ORDERS_CURRENT))
            .replace("{goal}", String(ORDERS_GOAL))}
        </span>
        <span className="sm:hidden text-foreground/90">
          {`${days}d ${hours}t · ${ORDERS_CURRENT}/${ORDERS_GOAL}`}
        </span>
        <a
          href="#bestilling"
          onClick={handleCta}
          className="text-primary hover:text-foreground transition-colors font-medium border-b border-primary/60 hover:border-foreground pb-0.5 whitespace-nowrap"
        >
          {t("countdown.bar_cta")}
        </a>
        <button
          onClick={handleDismiss}
          aria-label="Close"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-foreground/60 hover:text-foreground p-1"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default CountdownBar;
